/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { forwardRef } from 'react';
import { Box } from '@mui/system';

const UserColorSelect = forwardRef((props, ref) => {
  const { value, onChange, className } = props;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="select-color">Color</InputLabel>
      <Select
        labelId="select-color"
        id="color"
        value={value}
        label="Color"
        onChange={handleChange}
        ref={ref}
        classes={{ select: 'flex items-center space-x-12' }}
        defaultValue="#013BB1"
        size="small"
      >
        <MenuItem value="#013BB1" className="space-x-12">
          <Box
            className="w-12 h-12 shrink-0 rounded-full"
            sx={{ backgroundColor: "#013BB1" }}
          />
          <span>Blue</span>
        </MenuItem>
        <MenuItem value="#80F2E7" className="space-x-12">
          <Box
            className="w-12 h-12 shrink-0 rounded-full"
            sx={{ backgroundColor: "#80F2E7" }}
          />
          <span>Cyan</span>
        </MenuItem>
        <MenuItem value="#48BF91" className="space-x-12">
          <Box
            className="w-12 h-12 shrink-0 rounded-full"
            sx={{ backgroundColor: "#48BF91" }}
          />
          <span>Green</span>
        </MenuItem>
        <MenuItem value="#FFF54F" className="space-x-12">
          <Box
            className="w-12 h-12 shrink-0 rounded-full"
            sx={{ backgroundColor: "#FFF54F" }}
          />
          <span>Yellow</span>
        </MenuItem>
        <MenuItem value="#FF55BF" className="space-x-12">
          <Box
            className="w-12 h-12 shrink-0 rounded-full"
            sx={{ backgroundColor: "#FF55BF" }}
          />
          <span>Pink</span>
        </MenuItem>
        <MenuItem value="#FF5454" className="space-x-12">
          <Box
            className="w-12 h-12 shrink-0 rounded-full"
            sx={{ backgroundColor: "#FF5454" }}
          />
          <span>Red</span>
        </MenuItem>
        <MenuItem value="#8A2FFF" className="space-x-12">
          <Box
            className="w-12 h-12 shrink-0 rounded-full"
            sx={{ backgroundColor: "#8A2FFF" }}
          />
          <span>Purple</span>
        </MenuItem>
      </Select>
    </FormControl>
  );
});

export default UserColorSelect;
